// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-2bXJ2";
var _3 = "wrapper_handbag-1kBj-";
var _4 = "background-2YZOf";
var _5 = "wrapper_included-1HlgR";
var _6 = "weight-3Iy7G";
var _7 = "wrapper_small-I5-hw";
var _8 = "wrapper_medium-2o0FP";
var _9 = "wrapper_big-2ZWes";
var _a = "wrapper_bag-nasK8";
var _b = "weight__amount-2p65U";
var _c = "weight__measurement-1kqbY";
export { _1 as "__esModule", _2 as "wrapper", _3 as "wrapper_handbag", _4 as "background", _5 as "wrapper_included", _6 as "weight", _7 as "wrapper_small", _8 as "wrapper_medium", _9 as "wrapper_big", _a as "wrapper_bag", _b as "weight__amount", _c as "weight__measurement" }
export default { "__esModule": _1, "wrapper": _2, "wrapper_handbag": _3, "background": _4, "wrapper_included": _5, "weight": _6, "wrapper_small": _7, "wrapper_medium": _8, "wrapper_big": _9, "wrapper_bag": _a, "weight__amount": _b, "weight__measurement": _c }
